import { gold } from "@ant-design/colors"
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Modal, Space } from "antd"

type Props = {
  isOpen: boolean
  onOk: () => void
  onClose: () => void
}

const RestoreUserModal = ({ isOpen, onOk, onClose }: Props) => {
  return <Modal
    title={<Space><FontAwesomeIcon icon={faInfoCircle} color={gold.primary}/>Restore this user?</Space>}
    okText="Restore"
    cancelText="Cancel"
    open={isOpen}
    onOk={onOk}
    onCancel={onClose}
  />
}

export default RestoreUserModal